var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Delete member",
        label: "Yes, delete member",
        type: "error",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c("div", { staticClass: "flex flex-col gap-3 px-8" }, [
        _vm.appointmentChecking
          ? _c("div", { staticClass: "h-64 grid place-items-center" }, [
              _c("div", { staticClass: "blum-loader" })
            ])
          : _vm.userAppointments.length
          ? _c("div", { staticClass: "flex flex-col gap-2" }, [
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    attrs: { text: "This action will affect" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: _vm.totalAppointments }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "scheduled appointment(s)." }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Please resolve the appointment(s) before proceeding with the deletion."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "max-h-64 py-3 px-4 flex flex-col gap-1 bg-slate-200 rounded overflow-y-auto"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky top-0 z-10 w-44 py-1 px-2 flex items-center gap-2 bg-light-purple-100 rounded cursor-pointer",
                      on: { click: _vm.onCheckAppointment }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-4 w-4",
                        class: { "animate-spin": _vm.appointmentChecking },
                        attrs: { icon: "update" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        staticClass: "text-light-purple flex-shrink-0",
                        attrs: { text: "Refresh appointments" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.userAppointments, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.date,
                        staticClass: "flex items-center justify-between"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-slate-600",
                              attrs: {
                                text: _vm.displayDate({ date: item.date }) + ":"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-slate-800",
                              attrs: {
                                text:
                                  item.appointments.length + " appointment(s)"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/appointments/therapist?page=1&per_page=25&user_id=" +
                                _vm.user.id +
                                "&status=scheduled,in_progress&preview_type=list",
                              target: "_blank"
                            }
                          },
                          [
                            _c("BlInputButton", {
                              attrs: {
                                type: "outlined",
                                dense: "",
                                label: "View"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("BlTextBody2", {
              attrs: { text: "Are you sure you want to delete" }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "font-bold",
              attrs: { text: _vm.user.name + "?" }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              attrs: {
                text: "Once deleted, they will no longer have access to Blüm."
              }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              attrs: {
                text:
                  "Additionally, all data associated with this user will be tagged as"
              }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "font-bold",
              attrs: { text: "''Deleted User''." }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-705aec16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705aec16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/DeleteUserModal.vue
// module id = null
// module chunks = 